module.exports = __webpack_public_path__ + "529dc397e061704746658b89d5d67b10.svg";